<div [hidden]="!(isPatientAppReady$ | async)">
	<div class="title">{{ 'IntuitivePatient.PatientDetails' | translate }}</div>
	<tlk-card>
		<div tlkCardContent class="patient-details-content">
			<rx-patient></rx-patient>
		</div>
		<div tlkCardFooter class="footer">
			<button tlkButton (click)="onCreateClick()" [disabled]="(isValidToSave$ | async) === false">
				{{ 'IntuitivePatient.Create' | translate }}
			</button>
		</div>
	</tlk-card>
</div>
